import { SUBSCRIPTION } from '../../../../shared/constants/user-info/subscription';
import { CreateSubscriptionFormValues } from '../../../interfaces/createSubscription';

export const defaultFormValue = {
  name: '',
  subscriptionType: SUBSCRIPTION.SCAN_IQ,
  billingPeriodType: '',
  subscriptionPrice: {
    initialPlanPrice: '',
    initialPlanDuration: '',
    initialPlanUserFee: '',
    initialPlanOneTimeFee: '',
    monthlyRenewalPrice: '',
    monthlyRenewalFees: '',
  },
} as any as CreateSubscriptionFormValues;
